export default "__VITE_ASSET__DXw0WJRP__"